module.exports = __webpack_public_path__ + "r-v3/img/menu_call_white.759df3c9.svg";